module.exports = __webpack_public_path__ + "assets/images/ote_sport_1.635fdfdb9ffdfc890633bfde3512bbc9.png";